import moment from "moment";
import DateRangePickerComponent from "../../../components/common/CustomDateRangePicker";
import { Box, Table, Button, FormControl, Grid, InputAdornment, MenuItem, Select, styled, TableContainer, Paper, TableBody, TableCell, TableRow, Typography, Pagination, CircularProgress } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { useEffect, useState } from "react";
import ReportsTableHeader from "../report-table-header.component";
import { format } from "date-fns";
import AuthenticationPerformanceLoader from "../skeleton/authentication-performance-skeleton.component";
import ReportService from "../../../services/api/reports";
import ExportAlertNotificationDialog from "../../alert/export-alert-notification-dialog.component";
import CachedIcon from "@mui/icons-material/Cached";
import {useSnackbar} from "notistack";

const SmallSelect = styled(Select)(({ theme, fontColor }) => ({
    minWidth: 120,  // Adjust the width as needed
    height: 33,     // Adjust the height as needed
    fontSize: '0.875rem',  // Adjust the font size as needed
    '.MuiSvgIcon-root': {
        color: fontColor, // Change to your desired color
    },
    color: fontColor,
    backgroundColor: '#fff',
    border: "1px solid #7A78F7",
    "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 250, borderRadius: "5px" },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "& .MuiSelect-select": {
        fontSize: 12,
        fontStyle: 'italic'
    },
    "& .MuiMenuItem-root": {
        fontSize: 12,
    },
    "& .Mui-selected": {
        fontSize: 12,
        fontStyle: 'italic'
    },
}));

const AuthenticationPerformanceFilterComponent = (props) => {

    const {headers, getAuthenticationPerformance, reportPerformance, listProducts,
        isLoading, setPage, page} = props;

    const {enqueueSnackbar} = useSnackbar();

    const [product_name, setProductName] = useState("");
    const [open, setOpen] = useState(false)
    const [isLoadingAlertNotification, setIsLoadingAlertNotification] = useState(false);
    const [reportID, setReportID] = useState(null);

    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

    useEffect(() => {
        const product_code = product_name || '';

        let payload = {
            start_date: startDate,
            end_date: endDate,
            product_code: [product_code],
        }

        if (startDate && endDate) {
            getAuthenticationPerformance(payload);
        }
    }, [startDate, endDate, product_name, page]);

    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleChangeProductName = (event) => {
        setProductName(event.target.value);
    };

    const handleClose = () =>{
        setOpen(false)
    }

    const handleExport = () => {
        const product_code = product_name || '';

        let payload = {
            start_date: startDate,
            end_date: endDate,
            product_code: [product_code],
        }

        if (reportPerformance?.length > 0) {
            setIsLoadingAlertNotification(true);

            ReportService.exportAuthenticationPerformance(payload).then((res)=>{
                console.log('export authentication performance res here', res)
                setIsLoadingAlertNotification(false)
                setReportID(res?.data?.data?.report_id)
                setOpen(true)
            }).catch(()=>{
                setIsLoadingAlertNotification(false)
            })

        } else {
            enqueueSnackbar("No data to export", { 
                variant: "error",
                autoHideDuration: 3000
            });
        }
       
    }

    const itemsPerPage = 100;

    // Calculate the total number of pages
    const totalPages = Math.ceil((reportPerformance?.length || 0) / itemsPerPage);

    // Get the current items to display
    const currentItems = (reportPerformance || []).slice((page - 1) * itemsPerPage, page * itemsPerPage);

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleClearFilters = (e) => {
        setProductName("");
        setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
    }

    return (
        <Box>
            <Grid container sx={{ justifyContent: "flex-end", alignItems: "center", mt: 3}}>
                <Grid item xs={6}>
                    <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                        startIcon={<CachedIcon />} onClick={(e) => handleClearFilters(e)}
                    >
                        Clear Filters
                    </Button>
                </Grid>

                <Grid item xs={6} sx={{ display: 'flex', justifyContent: "flex-end" }}>
                <FormControl sx={{ width: 250 }}>
                    <SmallSelect
                        value={product_name}
                        onChange={handleChangeProductName}
                        displayEmpty
                        fontColor={'#5d5ed8'}
                        startAdornment={
                            <InputAdornment position="start">
                                <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                    Product Name:
                                </p>
                            </InputAdornment>
                        }
                    >
                        <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                            <em>Select Product</em>
                        </MenuItem>
                        
                        {listProducts?.map((list, index)=>{
                            return(
                                <MenuItem value={list?.product_code} sx={{ fontSize: 12 }}>
                                    {list?.product_name}
                                </MenuItem>
                            )
                        })}
                    </SmallSelect>
                </FormControl>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <DateRangePickerComponent
                        initialStartDate={startDate}
                        initialEndDate={endDate}
                        ranges={{
                            "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                            "This Month": [moment().startOf('month'), moment().endOf('month')],
                            "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                        }}
                        onDateRangeChange={handleDateRangeChange}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                        onClick={handleExport}
                        variant="contained"
                        startIcon= {isLoadingAlertNotification ? <CircularProgress sx={{color:'white'}} size={11} /> : <DownloadIcon />}
                        sx={{fontSize: 12, background: '#3333CFCE', color: '#fff', textTransform: 'none', "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                    >
                        {isLoadingAlertNotification ? "Exporting" : "Export"}
                    </Button>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ width: '100%', overflow: 'hidden', mt: 3,  }}>
                    <TableContainer sx={{ border: "1px solid #3333cf54", borderRadius: 2, width: "100%", maxHeight: 600}}>
                        <Table stickyHeader sx={{ minWidth: 650 }}>
                            <ReportsTableHeader headers={headers} />
                            {isLoading ? 
                                <TableBody>
                                    <AuthenticationPerformanceLoader/>
                                </TableBody>
                            :
                                <TableBody>
                                    {currentItems?.map((label, index) => (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell key={index} component="th" scope="row">
                                                {label.product_id}
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row">
                                                {label?.product_name}
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row">
                                                {label?.updated_time ? format(new Date(label?.updated_time), "PP"): 'NA'}
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row">
                                                {label.authentication_status}
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row">
                                                NA
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row">
                                                {label.product_code}
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row">
                                            {format(new Date(label?.created_time), "PP")}
                                            </TableCell>
                                            
                                        </TableRow>
                                    ))}
                                </TableBody>
                            }
                            
                        </Table>
                        
                        {/* ERROR MESSAGE */}
                        {!isLoading && reportPerformance?.length === 0 && <Box sx={{textAlign:'center', m: 2}}> <Typography sx={{color:'gray', fontSize: 12}}>No data available.</Typography></Box>}
                        
                    </TableContainer>
                    {/* PAGINATION */}
                    {!isLoading ?
                        <Box display="flex" justifyContent="center" mt={2} mb={2}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                sx={{
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        color: "#fff",
                                        backgroundColor: "#5959D8"
                                    }
                                }} 
                            />
                        </Box>
                    : null}
                </Paper>
            </Grid>
            {/* DIALOG */}
            <ExportAlertNotificationDialog open={open} reportID={reportID} handleClose={handleClose}/>
        </Box>
    )

}

export default AuthenticationPerformanceFilterComponent